
define('text!templates/modules/member/select/member-select-content.html',[],function () { return '<form class="panel-body member-select-content">\n    <ul class="menu-actions nav nav-pills"></ul>\n    <div class="search-input"></div>\n    <div class="group-tree"></div>\n    <div class="select-all-input"></div>\n    <div class="member-list"></div>\n</form>\n';});

